module.exports = __webpack_public_path__ + "img/privilege12.335a010e.png";